import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';

class ConfirmationScreen extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.manageSettingsData = this.manageSettingsData.bind(this);
    }

    toggle() {
        this.props.onToggle();
    }

    manageSettingsData() {
        this.props.onSave();
        this.toggle();
    }

    renderDeleteBtn() {
        return (
            <Button outline color="primary" onClick={this.manageSettingsData}>
                <MaterialIcon icon="delete" color="#0288D1" size={18} />{i18n.t('common:buttons.delete')}
            </Button>
        );
    }

    renderSaveBtn() {
        return (
            <Button color="primary" onClick={this.manageSettingsData}><MaterialIcon icon="done" color="#fff" size={18} /> {i18n.t('common:buttons.confirm')}</Button>
        );
    }

    render() {

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle}>
                    <ModalHeader className="modalHeader" toggle={this.toggle}>{this.props.message.header}</ModalHeader>
                    <ModalBody>
                        <p>{this.props.message.firstRow}<br />
                            {this.props.message.secondRow}</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.props.hasDeleteBtn ? this.renderDeleteBtn() : this.renderSaveBtn()}
                        <Button outline color="primary" onClick={this.toggle}>{i18n.t('common:buttons.cancel')}</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ConfirmationScreen;


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/pos/ConfirmationScreen.js